import React, { useState } from 'react'
import wallpaper from '../img/bg-2.jpg'
import Taskbar from '../components/Taskbar';
import RightNavPanel from '../components/RightNavPanel';
import Startmenu from './StartMenu';
import Calender from './Calender';
import HiddenIconTray from './HiddenIconTray';
import ThisPc from './ThisPc';
import DesktopIcons from './DesktopIcons';
import Overlay from './Overlay';

const Screen = () => {

  const [toggleNav, setToggleNav] = useState(false);
  const [startMenu, setStartMenu] = useState(false);
  const [toggleCalender, setToggleCalender] = useState(false);
  const [toggleTray, setToggletray] = useState(false);
  const [resize, setResize] = useState(false);
  const [close, setClose] = useState(false);
  const [minimize, setMinimize] = useState(false);
  const [brightness, setBrightness] = useState();
  const [volume, setVolume] = useState();
  const [night, setNight] = useState(false);

  const handleBrightness =(e)=>{
    setBrightness(e.target.value)
  }

  const handleVolume =(e)=>{
    setVolume(e.target.value)
  }

  const toggleStartMenu = ()=>{
    if(startMenu === false){
      setStartMenu(true)
      setToggleNav(false)
      setToggleCalender(false)
      setToggletray(false)
    }
    else{
      setStartMenu(false)
    }
  }


  const toggleSideNav = () => {
    if (toggleNav === false) {
      setToggleNav(true)
      setStartMenu(false)
      setToggleCalender(false)
      setToggletray(false)
    }
    else {
      setToggleNav(false)
    }
  }


  const toggleCalenderHandle = () =>{
    if(toggleCalender === false){
      setToggleCalender(true)
      setStartMenu(false)
      setToggleNav(false)
      setToggletray(false)
    }
    else{
      setToggleCalender(false)
    }
  }

  const toggleIconTray = ()=>{
    if(toggleTray === false){
      setToggletray(true)
      setStartMenu(false)
      setToggleNav(false)
      setToggleCalender(false)
    }
    else{
      setToggletray(false)
    }
  }

  const blur = () =>{
    if(toggleTray || toggleCalender || toggleNav || startMenu === true){
      setToggletray(false)
      setStartMenu(false)
      setToggleNav(false)
      setToggleCalender(false)
    }
  }

  const closeWindow = () =>{
    if(close === false){
      setClose(true)
    }
    else{
      setClose(false)
    }
  }

  const resizeWindow = () =>{
    if(resize === false){
      setResize(true)
    }
    else{
      setResize(false)
    }
  }

  const minimizeWindow = () =>{
    if(minimize === false){
      setMinimize(true)
    }
    else{
      setMinimize(false)
    }
  }

  const nightLightHandle =() =>{
    console.log('night light enabled')
    if(night === false)
    setNight(true)
    else{
      setNight(false)
    }
  }


  return (
    <div className={`relative w-[100vw] h-[100vh] overflow-hidden filter brightness-[${brightness /100}] ${night? 'grayscale': ''}`}>
      <img onClick={blur} className={`w-full h-full filter`} src={wallpaper} alt="" />

      <div className={`taskbar absolute bottom-0 z-10 `}>
        <Taskbar toggleSideNav={toggleSideNav} toggleStartMenu={toggleStartMenu} toggleCalenderHandle={toggleCalenderHandle} toggleIconTray={toggleIconTray} closeWindow={closeWindow}/>
      </div>

      <div className={`absolute ${toggleNav? '-translate-y-full':'translate-y-full'} pb-14 transition-transform ease-in-out delay-150 right-2`}>
        <RightNavPanel handleBrightness={handleBrightness} handleVolume={handleVolume} nightLightHandle={nightLightHandle} night={night} brightness={brightness} volume={volume}/>
      </div>

      <div className={`absolute left-[50%] -translate-x-[50%] ${startMenu? '-translate-y-full': 'translate-y-full'} pb-14 transition-all ease-in-out delay-150`}>  
        <Startmenu/>
      </div>

      <div className={`absolute ${toggleCalender? '-translate-y-full':'translate-y-full'} right-2 pb-14 transition-all ease-in-out delay-150`}>  
        <Calender/>
      </div>

      <div className={`absolute ${toggleTray? '-translate-y-full':'translate-y-full'} right-44 pb-12 transition-all ease-in-out delay-150`}>
        <HiddenIconTray/>
      </div>

      {/* <div className={`absolute ${toggleTray? '-translate-y-full':'translate-y-full'} right-44 pb-12 transition-all ease-in-out delay-150`}> */}
      <div className={`absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] z-20`}>
        <ThisPc closeWindow={closeWindow} resizeWindow={resizeWindow} minimizeWindow={minimizeWindow} resize={resize} close={close} minimize={minimize} />
      </div>

      <div className={`absolute top-0 left-0 `}>
        <DesktopIcons/>
      </div>
{/* 
      <div className={ `w-[50vw] h-[50vh] ${`bg-black/${brightness}`} absolute top-0 left-0 filter`}>
        <Overlay/>
      </div> */}

    </div>
  )
}

export default Screen
